import { render } from "./FamilyList.vue?vue&type=template&id=b6669afc&scoped=true"
import script from "./FamilyList.vue?vue&type=script&lang=js"
export * from "./FamilyList.vue?vue&type=script&lang=js"

import "./FamilyList.vue?vue&type=style&index=0&id=b6669afc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6669afc"]])

export default __exports__